import Vue from 'vue';
import Element from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en';
import 'element-theme-dark';
import 'element-ui/lib/theme-chalk/display.css';

Vue.use(Element, { locale })
